module.exports = __webpack_public_path__ + "static/redbull-7f058fa92fab7d93b8c6c8f90096d4ef.svg";